import { trackPromise } from "react-promise-tracker";
import ParametroConsultaAutorizaciones from "../Contenedores/Autorizaciones/ParametroConsultaAutorizaciones";
import SolicitudDetalleAutorizacion from "../Contenedores/Autorizaciones/SolicitudDetalleAutorizacion";
import { apiAutorizacion } from "../Utils/RutasApi";
import Http from "./Http";
import ParametroDetalleRevocacion from "../Contenedores/Autorizaciones/ParametroDetalleRevocacion";
import ParametroConsultaRevocatorias from "../Contenedores/Autorizaciones/ParametroConsultaRevocatorias";
import DocumentoRevocacion from "../Contenedores/Autorizaciones/DocumentoRevocacion";
import ParametroIncluirAutorizacion from "../Contenedores/Autorizaciones/ParametroIncluirAutorizacion";
import ParametroConsultaPersona from "../Contenedores/Autorizaciones/ParametroConsultaPersona";
import ParametroEliminarAutorizacion from "../Contenedores/Autorizaciones/ParametroEliminarAutorizacion";
import ParametroRevocarAutorizacion from "../Contenedores/Autorizaciones/ParametroRevocarAutorizacion";
import ParametroConsultaEliminadas from "../Contenedores/Autorizaciones/ParametroConsultaEliminadas";

export async function ObtengaUsuariosTramiteAutorizaciones() {
  const url = apiAutorizacion.ObtengaUsuariosTramiteAutorizaciones;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };
  return resultado.data;
}

export async function ConsultaAutorizaciones(
  parametro: ParametroConsultaAutorizaciones
) {
  const url = apiAutorizacion.ConsultarAutorizaciones;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function ObtengaDetalleAutorizacion(
  parametro: SolicitudDetalleAutorizacion
) {
  const url = apiAutorizacion.ObtengaDetalleAutorizacion;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function ObtengaDocumentoAutorizacion(parametro: any) {
  const url = apiAutorizacion.ObtengaDocumentoAutorizacion;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function ConsultaRevocaciones(
  parametro: ParametroConsultaRevocatorias
) {
  const url = apiAutorizacion.ConsultarRevocaciones;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function ObtengaDetalleRevocacion(
  parametro: ParametroDetalleRevocacion
) {
  const url = apiAutorizacion.ObtengaDetalleRevocacion;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function ObtengaUsuariosTramiteRevocatorias() {
  const url = apiAutorizacion.ObtengaUsuariosTramiteRevocaciones;
  let resultado = await trackPromise(Http.get<any>(url));
  if (
    Object.keys(resultado).length === 0 ||
    resultado === null ||
    resultado === undefined
  )
    return { key: "Ocurrio un error al cargar el combo", value: "-1" };
  return resultado.data;
}

export async function ObtengaDocumentoRevocacion(
  parametro: DocumentoRevocacion
) {
  const url = apiAutorizacion.ObtengaDocumentoRevocatoria;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function ConsultarPersonaParaAutorizacion(
  parametro: ParametroConsultaPersona
) {
  const url = apiAutorizacion.ConsultarPersonaParaAutorizacion;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function IncluirAutorizacion(
  parametro: ParametroIncluirAutorizacion
) {
  const url = apiAutorizacion.IncluirAutorizacion;
  let resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function ObtengaListaTiposDocumento() {
  const url = apiAutorizacion.ObtengaListaTiposDocumento;
  let resultado = await trackPromise(Http.get<any>(url));
  return resultado.data;
}

export async function ObtengaListaFormularios() {
  const url = apiAutorizacion.ObtengaFormularios;
  let resultado = await trackPromise(Http.get<any>(url));
  return resultado.data;
}

export async function EliminarAutorizacion(
  parametro: ParametroEliminarAutorizacion
) {
  const url = apiAutorizacion.ElimineAutorizacion;
  const resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function RevocarAutorizacion(
  parametro: ParametroRevocarAutorizacion
) {
  const url = apiAutorizacion.RevoqueAutorizacion;
  const resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}


export async function ConsultarAutorizacionesEliminadas(parametro: ParametroConsultaEliminadas){
  const url = apiAutorizacion.ConsultarAutorizacionesEliminadas;
  const resultado = await trackPromise(Http.post<any>(url, parametro));
  return resultado.data;
}

export async function ObtengaUsuariosRolEliminarAutorizaciones(){
  const url = apiAutorizacion.ObtengaUsuariosRolEliminarAutorizaciones;
  const resultado = await trackPromise(Http.get<any>(url));
  return resultado.data;
}

const ServicioAutorizaciones = {
  ObtengaUsuariosTramiteAutorizaciones,
  ConsultaAutorizaciones,
  ObtengaDetalleAutorizacion,
  ObtengaDocumentoAutorizacion,
  ConsultaRevocaciones,
  ObtengaDetalleRevocacion,
  ObtengaUsuariosTramiteRevocatorias,
  ObtengaDocumentoRevocacion,
  ConsultarPersonaParaAutorizacion,
  IncluirAutorizacion,
  ObtengaListaTiposDocumento,
  ObtengaListaFormularios,
  EliminarAutorizacion,
  RevocarAutorizacion,
  ConsultarAutorizacionesEliminadas,
  ObtengaUsuariosRolEliminarAutorizaciones
};

export default ServicioAutorizaciones;
